import { render, staticRenderFns } from "./AiChatDebugPanel.vue?vue&type=template&id=65f8a456&scoped=true&"
import script from "./AiChatDebugPanel.vue?vue&type=script&setup=true&lang=js&"
export * from "./AiChatDebugPanel.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AiChatDebugPanel.vue?vue&type=style&index=0&id=65f8a456&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f8a456",
  null
  
)

export default component.exports